import { render, staticRenderFns } from "./LabourActionSelectorModal.vue?vue&type=template&id=3cd35976"
import script from "./LabourActionSelectorModal.vue?vue&type=script&lang=js"
export * from "./LabourActionSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports